// This file was generated by lezer-generator. You probably shouldn't edit it.
import {LRParser, LocalTokenGroup} from "@lezer/lr"
export const parser = LRParser.deserialize({
  version: 14,
  states: "#YQ]QPOOPkOPOOOpQPO'#CeOOQO'#Co'#CoOOQO'#Cg'#CgQ]QPOOP!ROQO'#C^POOO)C>_)C>_OOQO,59P,59PO!^QPO,59POOQO-E6e-E6ePOOO'#Cf'#CfP!oOQO,58xPOOO,58x,58xOOQO1G.k1G.kPOOO-E6d-E6dPOOO1G.d1G.d",
  stateData: "!z~O^OSPOS_PQ~OSROTROUROWQO~O_UO~OSROTROUROVWOWQO~O`ZOaZOb]O~OSROTROUROV^OWQO~O`ZOaZOb`O~O",
  goto: "!UdPPePPPPPPhntPPPPPPP!ORVPXROQTXQ[UR_[QTOQXQTYTXXSOQTX",
  nodeNames: "⚠ LineComment BlockComment Program Identifier String Boolean ) ( Application",
  maxTerm: 19,
  nodeProps: [
    ["openedBy", 7,"("],
    ["closedBy", 8,")"]
  ],
  skippedNodes: [0,1,2,10],
  repeatNodeCount: 2,
  tokenData: "%q~R^XY}YZ}]^}pq}rs!`st#|xy$[yz$a}!O$f!P!Q$z!Q![$f!c!}$f#R#S$f#T#o$f~!SS^~XY}YZ}]^}pq}~!cVOr!`rs!xs#O!`#O#P!}#P;'S!`;'S;=`#v<%lO!`~!}OT~~#QRO;'S!`;'S;=`#Z;=`O!`~#^WOr!`rs!xs#O!`#O#P!}#P;'S!`;'S;=`#v;=`<%l!`<%lO!`~#yP;=`<%l!`~$PQ#Y#Z$V#h#i$V~$[OU~~$aOW~~$fOV~~$kTS~}!O$f!Q![$f!c!}$f#R#S$f#T#o$f~$}Qz{%T!P!Q%Y~%YO_~~%_SP~OY%YZ;'S%Y;'S;=`%k<%lO%Y~%nP;=`<%l%Y",
  tokenizers: [1, new LocalTokenGroup("j~RQYZXz{^~^Oa~~aP!P!Qd~iOb~~", 25, 16)],
  topRules: {"Program":[0,3]},
  tokenPrec: 0
})
